import { Component, OnInit, inject, model } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValueChangeEvent, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule, MatSnackBar } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import {
  MatSlideToggleModule,
} from '@angular/material/slide-toggle';

import {MatStepperModule} from '@angular/material/stepper';

import { StripeAPIService } from '../../services/stripe-api.service';
import { AmplifyModelService } from '../../services/amplify-model-service.service';
import { QuestionControlService } from '../../services/question-control.service';

import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { DynamicFormGroupComponent } from '../dynamic-form-group/dynamic-form-group.component';
import { QuestionBase, FormGroupQuestion } from '../../classes/questions';
import { CreateSubscriptionDialogComponent, StripeBody } from '../create-subscription-dialog/create-subscription-dialog.component';
import { ServiceAddressSelectorComponent } from '../service-address-selector/service-address-selector.component';
import { AggregatedServiceSelection } from '../../services/service-address.service';

export interface SubBuilderData {
  entitlements?: any[],
  customer?: any,
  stripeBody?: StripeBody,
  customerId?: string
}


@Component({
  selector: 'app-subscription-builder',
  imports: [MatSnackBarModule, MatListModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule, MatCheckboxModule, MatSelectModule, MatTabsModule, MatStepperModule, MatSlideToggleModule, CreateSubscriptionDialogComponent, ServiceAddressSelectorComponent, FormsModule, ReactiveFormsModule, DynamicFormComponent],
  templateUrl: './subscription-builder.component.html',
  styleUrl: './subscription-builder.component.css'
})
export class SubscriptionBuilderComponent implements OnInit {
  form!: FormGroup;
  subFormLoaded: boolean = false;
  priceBuilderFormLoaded: boolean = false;
  priceBuilderForm!: FormGroup;
  subForm!: FormGroup;

  subObj!: any;
  subMessage: string = '';

  serviceAddressStepControl = new FormControl<string[]>([], Validators.required); // Req 9.5/9.6
  aggregatedServiceSelections: AggregatedServiceSelection[] = [];

  subValueMap: any;
  // Limit the first stepper step to just these Sub fields; the rest (pricing,
  // billing schedule, etc.) are collected in later steps or not needed here.
  subStepFields: string[] = ['name', 'customer', 'primary_technician', 'primary_sales_rep'];
  readonly dialogRef = inject(MatDialogRef<SubscriptionBuilderComponent>);
  readonly dialog = inject(MatDialog);
  readonly data = inject<SubBuilderData>(MAT_DIALOG_DATA);

  /*
  isUpdate: boolean = false;



  //readonly entitlements = model(this.data.entitlements);
  readonly entitlements = this.data.entitlements;
  private ams = inject(AmplifyModelService);
  private _snackBar = inject(MatSnackBar);
  ddbSub: any;
  stripeBody!: StripeBody;
  stripeApi = inject(StripeAPIService);

  baseUrl: string = '';

  todayDayOfMonth: number = 0;
  todayMonthOfYear: number = 1;
  payLoad: any;

  maxIntervals: number = 36;
  intervalMap: any = {
    year: 3, month: 36, week: 156
  }

  previousEntitlementIds: string[] = [];
  previousServiceIds: string[] = [];

  serviceBaseItemsArr: StripeSubscriptionData[] = [];
  baseItemsArr: StripeSubscriptionData[] = [];

  //subNameControl = new FormControl('', Validators.required);
  billCycleControl = new FormControl('month', Validators.required);
  intervalCountControl = new FormControl(1, Validators.required);
  preferredBillMonthControl = new FormControl(1, Validators.required);
  preferredBillDateControl = new FormControl(0, Validators.required);
  cancelationControl = new FormControl(false);
  cancelationAmountControl = new FormControl(0);
  firstServiceFeeControl = new FormControl(150);
  servicesControl = new FormControl([], Validators.required);
  //entitlementsControl = new FormControl([], Validators.required);
  confirmPricesControl = new FormControl(false);

  serviceAddressQuestion: FormGroupQuestion<any> | null = null;

  totalSubscriptionPrice: number = 0;
  orderSummaryStr: string = '';
  periodStr: string = '';
  //discountPercent: number = 0;
  maxDiscountPercent: number = 25;
  maxMonths: number = 35; // 36 months is max number of months - one for default
  monthlyDiscount: number = (this.maxDiscountPercent / this.maxMonths) / 100;
  bundleDiscountPercent: number = 25;
  bundleDiscount: number = 0; // the total discount from all bundled items

  priceOverrides: any[] = [];
  servicePriceOverrides: any[] = []

  pbTotals: PriceBuilder[] = [];

  serviceOptions: any[] = [];
  */


  constructor(private fb: FormBuilder, private qcs: QuestionControlService) {

  }


  /**
  * On submit we call the stripeApi to create the subscription object in Stripe
  */
  /*
  async onSubmit() {
    if (this.subForm.dirty) {
      console.log('onSubmit subForm changed');
    }
    if (this.priceBuilderForm.dirty) {
      console.log('onSubmit priceBuilderForm changed');
    }
    //this.payLoad = this.form.getRawValue();
    this.setStripeSubscriptionValuesService();
    if (this.payLoad.add_cancellation_credit && this.payLoad.cancellation_credit_amount !== 0) {
      this.addCustomerCredit()
    }
    else {
      this.createStripeSubSession();
    }
  }
  */
  /**
  * Once the Sub item is created we trigger two actions. First, we update all
  * of the ServiceCustomer items. These will likely serve as entitlements.
  */
  /*
  async updateSubscriptionOnServiceCustomers(subId: string) {
    console.log('flowcheck will updateSubscriptionOnServiceCustomers');
    if (!this.entitlementsControl || !this.entitlementsControl.value) return;
    for (let serviceId of this.ddbSub.services) {
      try {
        let scItem = {
          id: serviceId,
          subId: subId
        };
        console.log('scItem', scItem);
        let res = await this.ams.updateItemForModel('ServiceCustomer', scItem);
        console.log('updateItem finished res', res);
        if (!res) {
          this._snackBar.open('Error updating ServiceCustomer', 'Dismiss');
          return;
        }

        if (res.errors && res.errors.length > 0) {
          let messages: string[] = [];
          res.errors.forEach((err) => {
            messages.push(err.message);
          })
          this._snackBar.open(messages.join('\n'), 'Dismiss');
        }
        else {
          console.log('flowcheck finished updateSubscriptionOnServiceCustomers for serviceId', serviceId);
          this._snackBar.open('Successfully linked service to subscription ', 'Dismiss');
        }
      } catch (error) {
        console.error('error in createItem', error);
      }
    }
  }*/

  loadSubForm (form:any) {
    this.subFormLoaded = true;
    this.subForm = form;
    this.form.addControl('sub_form', form);
  }

  loadPriceBuilderForm(form:any){
    this.priceBuilderFormLoaded = true;
    this.priceBuilderForm = form;
    this.form.addControl('price_builder', form);
  }

  subFormSubmit() {
    console.log('submitted subForm', this.subForm.getRawValue());
    this.subObj = this.subForm.getRawValue();
    this.subMessage = "Successfully created subscription in Complete Pest. Click next to setup pricing."
  }

  priceBuilderSubmit() {
    console.log('submitted priceBuilder', this.priceBuilderForm.getRawValue());
  }

  handleSubSubmitOutput(sub) {
    console.log('handleSubSubmitOutput sub', sub);
    this.subObj = sub;
    this.subMessage = "Successfully created subscription in Complete Pest. Click next to setup pricing."
  }

  handlePriceBuilderSubmitOutput(builder) {
    console.log('handleSubSubmitOutput builder', builder);
  }

  handleServiceAddressSelectionChange(event: {
    serviceAddressIds: string[];
    aggregatedServiceSelections: AggregatedServiceSelection[];
  }) {
    this.serviceAddressStepControl.setValue(event.serviceAddressIds); // empty array => control invalid => Req 9.5
    this.aggregatedServiceSelections = event.aggregatedServiceSelections;
  }

  onSubmit() {
    console.log('form submitted', this.form.getRawValue());
  }

  ngOnInit() {
    const parsedUrl = new URL(window.location.href);
    //this.subValueMap = {customerId: this.data.customer.id}
    console.log('SubscriptionBuilderComponent data', this.data);
    this.subValueMap = {
      customer: this.data.customer.id
    }
    console.log('SubscriptionBuilderComponent subValueMap', this.subValueMap);
    this.form = new FormGroup({});
    this.priceBuilderForm = new FormGroup({});
    this.subForm = new FormGroup({});

  }

}
